import { render } from "./warn1_tiny.vue?vue&type=template&id=042430e0&scoped=true"
import script from "./warn1_tiny.vue?vue&type=script&lang=js"
export * from "./warn1_tiny.vue?vue&type=script&lang=js"

import "./warn1_tiny.vue?vue&type=style&index=0&id=042430e0&lang=scss&scoped=true"
import "./warn1_tiny.vue?vue&type=style&index=1&id=042430e0&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042430e0"]])

export default __exports__